import {getNarrativeFormResultView} from "./formResultHelpers.js";
import {getFormCompletion} from "./formValidationHelpers.js";

export function normalizePositionMapConfig(config = {}) {
	return {
		...config,
		sections: Array.isArray(config.sections) ? config.sections : [],
		fields: Array.isArray(config.fields) ? config.fields : [],
	}
}

export function getPositionMapCompletion(config = {}, answers = {}) {
	const fields = normalizePositionMapConfig(config).fields
	const completion = getFormCompletion(config, answers)
	return {...completion, missing: fields.filter(field => completion.missingFieldIds.includes(field.id))}
}

export function getPositionMapSections(config = {}) {
	const normalized = normalizePositionMapConfig(config)
	const configured = normalized.sections.length ? normalized.sections : [{id: "default", title: normalized.title || "Questions", description: ""}]
	const sections = configured.map(section => ({...section, fields: []}))
	for (const field of normalized.fields) {
		const section = sections.find(item => item.id === field.sectionId) || sections[0]
		section.fields.push(field)
	}
	return sections
}

export function getMostRecentPositionResult(results = []) {
	const timestamp = value => value?.toMillis?.() || (value?.seconds ? value.seconds * 1000 : new Date(value || 0).getTime()) || 0
	return [...results].sort((a, b) => timestamp(b.createdAt) - timestamp(a.createdAt))[0] || null
}


export function getPositionMapResultView(config, result = {}, priorResults = []) {
	const view = getNarrativeFormResultView(config, result, priorResults, normalizePositionMapConfig)
	const withPosition = row => ({...row, sections: getPositionMapSections(row.config), completion: getPositionMapCompletion(row.config, row.answers)})
	return {...withPosition(view), priorResults: view.priorResults.map(withPosition)}
}
